export default __webpack_public_path__ + "static/media/jbc_2_jpeg.1d6c1421.jpg";